import { RoomDetailService } from '../shared/services/room-detail.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ ],
  imports: [
    CommonModule,
  ],
  providers: [
    RoomDetailService
  ]
})
export class RoomDetailModule { }
